import type { StarsWebExtraWallet } from '@swf/core/models/sports/types/extraWallets';

import { getIsWalletBonusCash, getIsWalletFreeBet } from './getIsWallet';

export const getDisplayableWallets = (
  wallets: StarsWebExtraWallet[],
  isBonusCashEnabled: boolean,
  isFreeBetsEnabled: boolean
): StarsWebExtraWallet[] =>
  wallets.filter(
    (wallet) =>
      (isBonusCashEnabled && getIsWalletBonusCash(wallet)) ||
      (isFreeBetsEnabled && getIsWalletFreeBet(wallet))
  );
